import React, {Component} from 'react';
import L from 'leaflet';
import './Map.css';
import Navbar from "../Navbar/Navbar";
import {Redirect} from 'react-router-dom';

export default class Maps extends Component {
    state = {
        LATITUDE: '',
        LONGITUDE: ''
    };

    constructor(props) {
        super(props);
        fetch(`http://iotjokebase.herokuapp.com/mapdata?uuid=${localStorage.getItem('uuid')}&mapname=${localStorage.getItem('mapName')}`).then(resp => {
            resp.json().then(jsnRes => {
                if (jsnRes.data !== 'No Such Map') {
                    console.log(jsnRes);
                    this.setState({LATITUDE: jsnRes.data.LATITUDE, LONGITUDE: jsnRes.data.LONGITUDE});
                    this.renderMap();
                }
            }).catch(jsnErr => {
                console.log('JSON Error : ' + jsnErr.message);
            });
        }).catch(err => {
            console.log('Fetch Error');
        });
    }

    renderMap = () => {
        var mymap = L.map('mapid').setView([this.state.LATITUDE, this.state.LONGITUDE], 13);

// const attributon = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
//
// const tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
//
// const tiles = L.tileLayer(tileUrl, {attributon});
//
// tiles.addTo(mymap);
//

        const accessToken = 'pk.eyJ1IjoiZGF6emhlcmUiLCJhIjoiY2p3OWVtZWo5MG51ODN5cXJiaXhreWt3eSJ9.SYcLcUngto2ePncfP2yBnA';
        // const  accessToken = '';

        L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'mapbox.streets',
            accessToken: accessToken
        }).addTo(mymap);


        L.marker([this.state.LATITUDE, this.state.LONGITUDE]).addTo(mymap);


        L.circle([this.state.LATITUDE, this.state.LONGITUDE], {
            color: '#beff66',
            fillColor: '#beff66',
            fillOpacity: 0.5,
            radius: 500
        }).addTo(mymap);
    };

    componentDidMount() {
        document.title = 'Map';
    }

    redirectToLogin = () => {
        if (localStorage.getItem('uuid') === 'undefined' || localStorage.getItem('uuid') === null) {
            return (<Redirect to='/'/>);
        }
    };

    render() {
        return (<div>
            {this.redirectToLogin()}
            <Navbar/>
            <div id="mapid"></div>
        </div>);
    }
}
